/* AI Semantic Search widget — calls the Supabase ai-search-search Edge Function
   and renders matching products in-place. No navigation to the native search page. */
(function () {
  "use strict";

  var euro = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

  function formatPrice(value) {
    var n = Number(value);
    return isNaN(n) ? "" : euro.format(n);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  // Quick-pick moods. Each chip fills the box with its phrase and runs the search.
  // Edit the label/query/icon here to retune the presets.
  var MOODS = [
    {
      label: "Low mood",
      query: "I feel low and unmotivated",
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>',
    },
    {
      label: "Stressed",
      query: "I feel stressed and anxious",
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="19" x2="8" y2="21"/><line x1="16" y1="19" x2="16" y2="21"/><line x1="12" y1="21" x2="12" y2="23"/><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"/></svg>',
    },
    {
      label: "Feeling down",
      query: "I feel sad and down",
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M16 16s-1.5-2-4-2-4 2-4 2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>',
    },
    {
      label: "Low energy",
      query: "I feel tired with low energy",
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    },
    {
      label: "Trouble sleeping",
      query: "I have trouble sleeping",
      icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
    },
  ];

  // Pull the product thumbnail from Shopify's own storefront JSON (same-origin,
  // no auth). Keeps images out of the DB/ingest pipeline. Removes the <img> if
  // the product has no image or the fetch fails.
  function loadProductImage(handle, img) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        var src = p && (p.featured_image || (p.images && p.images[0]));
        if (!src) {
          img.remove();
          return;
        }
        if (src.indexOf("//") === 0) src = "https:" + src;
        src += (src.indexOf("?") === -1 ? "?" : "&") + "width=160"; // small CDN variant
        img.src = src;
      })
      .catch(function () {
        img.remove();
      });
  }

  function buildMoods(container, onPick) {
    if (!container) return;
    MOODS.forEach(function (mood) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ai-search__mood";
      btn.title = mood.label;
      btn.setAttribute("aria-label", mood.label);
      btn.innerHTML = mood.icon; // trusted, static markup defined above
      btn.addEventListener("click", function () {
        onPick(mood.query);
      });
      container.appendChild(btn);
    });
  }

  function initWidget(root) {
    var form = root.querySelector("[data-ai-search-form]");
    var input = root.querySelector("[data-ai-search-input]");
    var statusEl = root.querySelector("[data-ai-search-status]");
    var resultsEl = root.querySelector("[data-ai-search-results]");
    var moodsEl = root.querySelector("[data-ai-search-moods]");

    var functionUrl = root.getAttribute("data-function-url");
    var anonKey = root.getAttribute("data-anon-key");
    var limit = parseInt(root.getAttribute("data-results-count"), 10) || 8;
    var addToCartEnabled = root.getAttribute("data-add-to-cart") === "true";
    var disclaimer = (root.getAttribute("data-disclaimer") || "").trim();

    function setStatus(message) {
      statusEl.textContent = message || "";
    }

    function renderResults(results, answer) {
      resultsEl.innerHTML = "";
      setStatus("");
      results = results || [];

      // AI-generated note first (with the fixed disclaimer), then the product list.
      if (answer) {
        var note = el("div", "ai-search__answer");
        note.appendChild(el("p", "ai-search__answer-text", answer));
        if (disclaimer) {
          note.appendChild(el("p", "ai-search__disclaimer", disclaimer));
        }
        resultsEl.appendChild(note);
      }

      if (!results.length) {
        if (!answer) {
          setStatus("No matching products. Try describing it differently.");
        }
        return;
      }
      var grid = el("div", "ai-search__grid");

      results.forEach(function (product) {
        var card = el("div", "ai-search__card");
        var link = el("a", "ai-search__card-link");
        link.href = "/products/" + product.handle;
        link.target = "_blank";
        link.rel = "noopener";

        var img = el("img", "ai-search__card-img");
        img.alt = "";
        img.loading = "lazy";
        img.addEventListener("error", function () {
          img.remove();
        });
        link.appendChild(img);
        loadProductImage(product.handle, img);

        var body = el("div", "ai-search__card-body");
        body.appendChild(el("span", "ai-search__card-title", product.title));
        if (product.price != null) {
          body.appendChild(el("span", "ai-search__card-price", formatPrice(product.price)));
        }
        link.appendChild(body);
        card.appendChild(link);

        if (addToCartEnabled && product.variant_id) {
          var btn = el("button", "ai-search__add", "Add to cart");
          btn.type = "button";
          btn.addEventListener("click", function () {
            addToCart(product.variant_id, btn);
          });
          card.appendChild(btn);
        }
        grid.appendChild(card);
      });
      resultsEl.appendChild(grid);
    }

    function addToCart(variantId, btn) {
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          btn.textContent = "Added ✓";
          document.dispatchEvent(new CustomEvent("ai-search:added"));
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = "Try again";
          btn.disabled = false;
        });
    }

    function search(query) {
      if (!functionUrl || !anonKey) {
        setStatus("Search is not configured yet.");
        return;
      }
      setStatus("Searching…");
      resultsEl.innerHTML = "";
      fetch(functionUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: anonKey,
          Authorization: "Bearer " + anonKey,
        },
        body: JSON.stringify({ query: query, limit: limit }),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.error || "Search failed");
            return body;
          });
        })
        .then(function (body) {
          renderResults(body.results || [], body.answer || "");
        })
        .catch(function (err) {
          console.error("[ai-search]", err);
          var msg = (err && err.message) || "";
          setStatus(/too many requests/i.test(msg)
            ? msg
            : "Something went wrong. Please try again.");
        });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault(); // never navigate to the native search page
      var query = (input.value || "").trim();
      if (query.length === 0) {
        setStatus("Type what you're looking for.");
        return;
      }
      search(query);
    });

    buildMoods(moodsEl, function (query) {
      input.value = query;
      search(query);
    });
  }

  function init() {
    document.querySelectorAll("[data-ai-search]").forEach(initWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
